<template>
  <div>
    <div class="sousuobanner">
      <img :src="baseApi+'webimages/sousuobanner.jpg'" />
    </div>
    <div class="searchresult">
      <div class="title web"><span><router-link to="/">首页</router-link><a href="javascript:;" class="cur">搜索结果</a></span>搜索结果</div>
      <div class="searchcont01">
        <div class="web">

          <div class="searchtitle01">未找到对应结果</div>
          <div class="resultlist01">
            <ul>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/search.vue